var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'shift-creator-edit',
  created () {
    this.search()
  },
  data () {
    return {
      selectedUser: null,
      searchCallbackFlag: false
    }
  },
  computed: {
    shiftEditCreators () {
      return this.$store.getters.shiftEditCreators
    },
    loading () {
      return this.$store.getters.apiLoading
    },
    shiftEditCreatorShop () {
      return this.$store.getters.shiftEditCreatorShop
    },
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    timeStamp() {
      var d = new Date()
      var year  = d.getFullYear()
      var month = d.getMonth() + 1
      var day   = d.getDate()
      var hour  = (d.getHours() < 10) ? '0' + d.getHours()   : d.getHours()
      var min   = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec   = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year +''+ month +''+ day +''+ hour +''+ min +''+ sec
    },
    isShopMaster () {
      return this.$store.getters.shopMaster
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function() {
      this.searchCallbackFlag = false
      var data = {}
      var self = this
      var callback = function () {
        for (var i = 0; i < self.shiftEditCreators.length; i++) {
          if (self.shiftEditCreators[i].attributes['is-shift-creator'] === 1) {
            self.selectedUser = self.shiftEditCreators[i].id
            break
          }
        }
        self.searchCallbackFlag = true
      }
      this.$store.dispatch('SHIFT_CREATOR_EDIT_SEARCH', { id: this.$route.params.id, data: data, callback: callback })
    },
    goBack: function () {
      if (this.isShopMaster) {
        this.$router.push({ path: '/'})
      } else {
        this.$router.push({ path: '/shift_creators'})
      }
    },
    onClickSave: function () {
      var self = this
      var data = { 'user_id': this.selectedUser }
      this.$store.dispatch('SHIFT_CREATOR_UPDATE', { id: this.$route.params.id, data: data, callback: function (){
        self.goBack()
      }})
    },
    /** 画像押下 */
    onClickImageModalShow: function (user) {
      var button = document.getElementById('imageModalButton')
      var img    = document.getElementById('imageModalImg')
      var text   = document.getElementById('imageModalText')
      img.src = user.attributes['avartar-path'] + '?token=' + this.authToken + "&timestamp=" + this.timeStamp
      text.textContent = ''
      button.click() // モーダル表示 イベント発火
    },
    onClickClear: function () {
      this.selectedUser = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/shift-creator-edit.js